/*
    © 2022 EcomGradautes.com
    https://www.ecomgraduates.com
*/
// Theme info in console
console.log('Developed  by EcomGraduates LLC | Learn more at https://www.ecomgraduates.com')

// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el))

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary')

// Shopify's errors messages - Add BS classes
const errors = document.querySelector('.errors')
if (errors) {
    errors.classList.add('alert', 'alert-danger')
}

// Debounce - helper function
// https://stackoverflow.com/a/42554614/5917894
window.debounce = (callback, wait = 200) => {
    let timeout
    return (...args) => {
        const context = this
        clearTimeout(timeout)
        timeout = setTimeout(() => callback.apply(context, args), wait)
    }
}

// Throttle - helper function
window.throttle = (callback, limit = 200) => {
    let wait = false
    return () => {
        if (!wait) {
            callback.call()
            wait = true
            setTimeout(() => {
                wait = false
            }, limit)
        }
    }
}

// Resize Shopify images - helper function
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba
window.resizeImage = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
            // eslint-disable-next-line no-param-reassign
            crop = `_crop_${crop}`
        }
        return `_${size}${crop}${match}`
    })

// Format money - helper function
// https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
window.formatMoney = (cents, format) => {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '')
    }

    let value = ''
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    const formatString = (format || window.money_format)

    function defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
    }

    function formatWithDelimiters (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (Number.isNaN(number) || number == null) { return 0 }

        number = (number / 100.0).toFixed(precision)

        const parts = number.split('.')
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
    }

    switch (formatString.match(placeholderRegex)[1]) {
    case 'amount': value = formatWithDelimiters(cents, 2); break
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break
    }

    return formatString.replace(placeholderRegex, value)
}

// Share links using WebShare API
window.onLinkShare = (btn, e) => {
    if (navigator.share) {
        navigator.share({
            title: btn.dataset.shareTitle,
            url: btn.dataset.shareUrl
        })
    } else {
        const popover = bootstrap.Popover.getOrCreateInstance(btn, {
            content: `
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" value="${btn.dataset.shareUrl}">
                    <button id="btn-share-copy" class="btn btn-outline-secondary" type="button">${btn.dataset.textCopy}</button>
                </div>
            `,
            html: true,
            sanitize: false,
            placement: 'top'
        })

        popover.show()

        document.querySelector('#btn-share-copy')?.addEventListener('click', (e) => {
            navigator.clipboard.writeText(btn.dataset.shareUrl)
            e.target.textContent = btn.dataset.textCopied
        })

        setTimeout(() => {
            popover.hide()
            btn.blur()
        }, 4000)
    }
}

// Shopify's recommended products
// https://shopify.dev/themes/product-merchandising/recommendations
const initRecommendedProducts = async () => {
    const section = document.querySelector('.recommended-products')

    if (!section) {
        return
    }

    const {
        sectionId, baseUrl, productId, limit
    } = section.dataset

    const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`

    const response = await fetch(url)
    const data = await response.text()

    section.closest('.shopify-section').outerHTML = data
}
initRecommendedProducts()

// Listen for changes in the Shopify Theme Editor
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
})

// Detect when element is within the scroll view
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterViewAnimations = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // console.log(entry)
                entry.target.classList.add('entered')
                entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
                    el.classList.remove('opacity-0')
                    el.classList.add(el.dataset.animateClass)
                })
            }
        })
    }, { threshold: 0, rootMargin: '0px 0px -200px 0px' })

    document.querySelectorAll('.enter-view').forEach((el) => {
        observer.observe(el)
    })
}
initEnterViewAnimations()

// Fix EnterView animations within Shopify Theme Editor
document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.enter-view').forEach((enterViewEl) => {
        enterViewEl.classList.add('entered')
        document.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
            el.classList.remove('opacity-0')
        })
    })
})

// Offcanvas mobile menu
document.querySelector('#navbar-offcanvas').addEventListener('show.bs.offcanvas', () => {
    document.querySelector('#navbar-offcanvas').style.top =
        document.querySelector('#navbar').getBoundingClientRect().bottom + 'px'

    document.querySelector('#navbar .nav-link-toggle-nav').classList.add('is-open')
    document.querySelector('#navbar .svg-icon-menu').style.display = 'none'
    document.querySelector('#navbar .svg-icon-close').style.display = 'block'
})

document.querySelector('#navbar-offcanvas').addEventListener('hide.bs.offcanvas', () => {
    document.querySelector('#navbar .nav-link-toggle-nav').classList.remove('is-open')
    document.querySelector('#navbar .svg-icon-menu').style.display = 'block'
    document.querySelector('#navbar .svg-icon-close').style.display = 'none'
})

// RellaxJS plugin
// https://github.com/dixonandmoe/rellax
const initRellax = () => {
    if (!document.querySelector('.rellax')) return

    // eslint-disable-next-line no-unused-vars
    const rellax = new Rellax('.rellax', {
        center: true
    })

    setInterval(() => {
        rellax.refresh()
    }, 2000)
}
initRellax()

// Policies page - add nav on the top
const addNavInPoliciesPages = () => {
    document.querySelectorAll('.shopify-policy__container').forEach((container) => {
        const currentPageTitle = document.querySelector('.shopify-policy__title h1').textContent
        console.log(currentPageTitle)

        container.insertAdjacentHTML('afterbegin', `
            <ul class="nav justify-content-center">
                <li class="nav-item">
                    <a 
                        class="nav-link ${currentPageTitle === 'Terms of service' ? 'active fw-bold border-bottom border-primary' : ''}" 
                        aria-current="${currentPageTitle === 'Terms of service' ? 'page' : ''}" 
                        href="/policies/terms-of-service">
                        Terms of service
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        class="nav-link ${currentPageTitle === 'Privacy policy' ? 'active fw-bold  border-bottom border-primary' : ''}"
                        aria-current="${currentPageTitle === 'Privacy policy' ? 'page' : ''}"
                        href="/policies/privacy-policy">
                        Privacy policy
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        class="nav-link ${currentPageTitle === 'Shipping policy' ? 'active fw-bold  border-bottom border-primary' : ''}"
                        aria-current="${currentPageTitle === 'Shipping policy' ? 'page' : ''}"
                        href="/policies/shipping-policy">
                        Shipping Policy
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        class="nav-link ${currentPageTitle === 'Refund policy' ? 'active fw-bold border-bottom border-primary' : ''}" 
                        aria-current="${currentPageTitle === 'Refund policy' ? 'page' : ''}"
                        href="/policies/refund-policy">
                        Refund Policy
                    </a>
                </li>
            </ul>
        `)
    })
}
addNavInPoliciesPages()

// Newsletter Parallax Cone Fix for Safari
if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    document.querySelectorAll('.newsletter-cone').forEach((el) => el.classList.add('d-none'))
    setTimeout(() => {
        document.querySelectorAll('.newsletter-cone').forEach((el) => el.classList.remove('d-none'))
    }, 3000)
}
